import React from 'react';
import { ActivityIndicator as RNActivityIndicator, ActivityIndicatorProps as RNActivityIndicatorProps } from 'react-native';

import { useTheme } from '@/components/theme-provider';

export interface ActivityIndicatorProps extends RNActivityIndicatorProps {
	color?: string;
}

export const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({
	color,
	...props
}) => {
	const theme = useTheme();

	return (
		<RNActivityIndicator
			color={color || theme.colors.primary}
			{...props}
		/>
	);
};
